// extracted by mini-css-extract-plugin
module.exports = {"stepCountContent":"ConsumablesSectionTitle_stepCountContent__vKXzg","stepCountLabel":"ConsumablesSectionTitle_stepCountLabel__9Abh0"};